import { settingsActions } from './actions';

const settingsInitState = {
  settingsList: null,
  loading: false,
  saving: false,
  error: null,
};

export function settingsReducer(state = settingsInitState, { type, payload }) {
  switch (type) {
    case settingsActions.LOAD_SETTINGS_LIST:
      return {
        ...state,
        loading: true,
      };
    case settingsActions.LOAD_SETTINGS_LIST_SUCCESS:
      return {
        ...state,
        settingsList: payload.data,
        loading: false,
      };
    case settingsActions.LOAD_SETTINGS_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: payload.error,
      };

    case settingsActions.UPDATE_SETTINGS:
      return {
        ...state,
        saving: true,
      };
    case settingsActions.UPDATE_SETTINGS_SUCCESS:
      return {
        ...state,
        saving: false,
      };
    case settingsActions.UPDATE_SETTINGS_FAIL:
      return {
        ...state,
        saving: false,
        error: payload.error,
      };

    default:
      return state;
  }
}
